var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),(_vm.currentAccount.mayNavigate())?_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Übersicht',
          icon: 'ni ni-chart-pie-35 text-info',
          path: '/portal'
        }}}),(_vm.currentAccount.isUser())?_c('sidebar-item',{attrs:{"link":{
          name: 'Angebote / Anträge',
          icon: 'fas fa-car-crash text-info',
          path: '/offers'
        }}}):_vm._e(),(_vm.currentAccount.isUser())?_c('sidebar-item',{attrs:{"link":{
          name: 'EvB',
          icon: 'fas fa-id-card text-info',
          path: '/evbs'
        }}}):_vm._e(),(_vm.currentAccount.isUser())?_c('sidebar-item',{attrs:{"link":{
          name: 'Dokumente',
          icon: 'fas fa-file text-info',
          path: '/documents'
        }}}):_vm._e(),(_vm.currentAccount.isUser())?_c('sidebar-item',{attrs:{"link":{
          name: 'Training',
          icon: 'fas fa-video text-info',
          path: '/training'
        }}}):_vm._e()],1),_c('template',{slot:"links-after"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"navbar-heading p-0 text-muted"},[_vm._v("TLP Service")]),_c('b-nav',{staticClass:"navbar-nav mb-md-3"},[_c('b-nav-item',{attrs:{"href":"https://schulligen.de"}},[_c('i',{staticClass:"ni ni-ni ni-satisfied"}),_c('b-nav-text',{staticClass:"p-0"},[_vm._v("Hilfe & Support")])],1)],1)],1)],2):_vm._e(),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }